import React, { useEffect, useRef } from 'react';

import { NullErrorBoundary } from '@atoms';

import styles from './MatrixRain.module.scss';

import { getRandomInt } from '../../../helpers';

const letters = ['4', '0'];
const fontSize = 14;

function MatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement>();
  const dropsRef = useRef<number[]>([]);

  useEffect(() => {
    function adjustWindowSize() {
      if (canvasRef.current) {
        const canvas = canvasRef.current;

        canvas.height = window.innerHeight;
        canvas.width = window.innerWidth;

        const length = Math.floor(canvas.width / fontSize);
        dropsRef.current = new Array(length).fill(0).map(() => getRandomInt(length));
      }
    }

    adjustWindowSize();

    window.addEventListener('resize', adjustWindowSize);

    return () => window.removeEventListener('resize', adjustWindowSize);
  }, []);

  useEffect(() => {
    let animationFrameId: number;
    let timeoutId: number;

    function draw() {
      if (canvasRef.current && dropsRef.current) {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        const drops = [...dropsRef.current];

        context.fillStyle = 'rgba(255, 255, 255, .1)';
        context.fillRect(0, 0, canvas.width, canvas.height);

        drops.forEach((drop, index) => {
          context.fillStyle = '#9aca3c';
          context.font = '14px Helvetica neue';
          context.fillText(letters[getRandomInt(letters.length)], index * fontSize, drop * fontSize);

          drops[index] += 1;
          if (drops[index] * fontSize > canvas.height && Math.random() > 0.95) {
            drops[index] = 0;
          }

          if (drops.length === dropsRef.current.length) {
            dropsRef.current = drops;
          }
        });
      }

      timeoutId = window.setTimeout(() => {
        animationFrameId = window.requestAnimationFrame(draw);
      }, 50);
    }

    animationFrameId = window.requestAnimationFrame(draw);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <NullErrorBoundary>
      <canvas ref={canvasRef} className={styles.canvas} />
    </NullErrorBoundary>
  );
}

export default MatrixRain;
